import { createApp } from 'vue';
import App from './App.vue';
import Quasar from 'quasar/src/vue-plugin.js';;
import { createGettext } from 'vue3-gettext';
import quasarUserOptions from './quasar-user-options';
import router from './router';
import translations from '../locales';
import { HttpPlugin, PostMessage, Startup } from './plugins';
import store from './store';
import { HubSessionService } from './services/hub-session.service';
import StackKeepAlive from 'stack-keep-alive/dist/library.esm';

// Obter idioma salvo ou usar padrão
const savedLanguage = localStorage.getItem('userLanguage') || 'es';

const app = createApp(App);

// Inicia listener permanente para receber token atualizado do Hub via postMessage
HubSessionService.initSessionListener();
app.use(Quasar, quasarUserOptions);
app.use(store);
app.use(router);
app.use(
  createGettext({
    availableLanguages: {
      en_US: 'English',
      pt_BR: 'Português (Brasil)',
      es: 'Español',
    },
    defaultLanguage: savedLanguage,
    silent: true,
    translations,
  })
);
app.use(HttpPlugin);
app.use(PostMessage);
app.use(StackKeepAlive);

app.use(Startup, {
  start: () => {},
  app,
});

app.mount('#app');
